// initial state
import * as base from "./base.js";
const water_commentName = "/admin/api/water_comment";

const obj = base.setBaseUrl("water_comment", water_commentName);
const a = Object.assign(obj);
export default a;
